import React, { useState } from "react";
import singingGirl from "../../assets/singingGirl.svg";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { testimonialImages } from "../../utils/constants";
import YoutubeModal from "../custom/YoutubeModal";
import CustomHeading from "../custom/CustomHeading";
import rightArrowImg from "../../assets/rightarrow.png";
import leftArrowImg from "../../assets/leftarrow.png";

const HomeTestimonialSlider = ({ bgColor }) => {
  const [youtubeModal, setYoutubeModal] = useState(false);
  const [youtubeUrl, setYoutubeUrl] = useState(null);
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    centerMode: true,
    centerPadding: "0px",
    nextArrow: (
      <div>
        <img className="custom-arrow" src={rightArrowImg} alt="Next" />
      </div>
    ),
    prevArrow: (
      <div>
        <img className="custom-arrow" src={leftArrowImg} alt="Previous" />
      </div>
    ),
  };
  return (
    <div
      className="relative flex lg:flex-row flex-col lg:h-[33rem] lg:px-[4%] 2xl:px-[6%] px-[2%] lg:py-[40px] py-[50px] items-center lg:gap-[3rem] gap-[1.5rem] "
      style={{
        background: bgColor ?? "#e6ebff",
      }}
    >
      <img
        src={singingGirl}
        alt="singing girl"
        className="absolute w-[50px] sm:w-[140px] lg:w-[160px] h-[90px] sm:h-[200px] lg:h-[220px] right-[0%] bottom-0 sm:block hidden"
      />

      <div className="w-[80%]  relative mx-auto lg:w-[55%]">
        {/* <img
        src={mpFrame}
        className="absolute top-[-10px] left-0 w-full h-[400px] z-20" // Keep it behind
        alt="frame"
      /> */}
        <Slider {...settings} className="sm:px-5 px-2">
          {testimonialImages?.map((item, index) => (
            <div
              className="group relative cursor-pointer sm:w-full w-[310px]  lg:h-[400px] sm:h-[300px] h-[250px]"
              onClick={() => {
                setYoutubeModal(true);
                setYoutubeUrl(item?.link);
              }}
              key={index}
            >
              <img
                src={window.innerWidth < 450 ? item?.mobileImg : item?.img}
                alt={`testimonial-${index}`}
                className="w-full lg:h-[400px] sm:h-[300px] h-[250px] rounded-md cursor-pointer mr-2"
              />
              <div className="absolute rounded-md inset-0 flex items-center justify-center bg-black bg-opacity-20">
                <svg
                  className="w-16 h-16 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M8 5v14l11-7z" />
                </svg>
              </div>
            </div>
          ))}
        </Slider>
      </div>
      <div className="lg:w-[45%] lg:mt-0 mt-10  relative flex flex-col items-center lg:items-start font-Lato font-semibold text-[34px] sm:text-[60px] leading-[40px] sm:leading-[72px]">
        <CustomHeading
          text={"Voices of Love"}
          textSize="54px"
          textColor="#d31c4f"
          showHeart={true}
          smTextSize="34px"
        />
        <CustomHeading
          text={"Parents Share!"}
          textSize="54px"
          marginTop={"10px"}
          smTextSize="34px"
        />
      </div>
      {youtubeModal && (
        <YoutubeModal url={youtubeUrl} setOpenModal={setYoutubeModal} />
      )}
    </div>
  );
};

export default HomeTestimonialSlider;
